import { get } from '../../utils/object-helpers';

<if(input && state.hasCategories)>
    <button
        class="str-left-nav-button"
        data-track=state.tracking
        aria-expanded=state.ariaExpanded
        aria-controls="str-left-nav"
        on-click("toggleLeftNav")>

        <ebay-menu-24-icon/>
        <span class="clipped">${state.a11yTitle}</span>
        <if(state.ariaExpanded === 'true')>
            <span class=`str-left-nav-button__label ${state.labelClass}`>${state.hideLabel}</span>
        </if>
        <else>
            <span class=`str-left-nav-button__label ${state.labelClass}`>${state.showLabel}</span>
        </else>
    </button>
</if>
